"use client";

import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 16px 24px 64px;
  @media (min-width: 1024px) {
    padding: 64px 80px 128px;
  }
`;

export const Inner = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1440px;
`;
